import { render, staticRenderFns } from "./EurekersSchool.vue?vue&type=template&id=e89afcca&scoped=true&"
import script from "./EurekersSchool.vue?vue&type=script&lang=js&"
export * from "./EurekersSchool.vue?vue&type=script&lang=js&"
import style0 from "./EurekersSchool.vue?vue&type=style&index=0&id=e89afcca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e89afcca",
  null
  
)

export default component.exports